import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext.jsx'

// Admin landing: users, categories, courses, payments, organization.

export function AdminPage() {
  const { t } = useTranslation()
  const { user, loading } = useAuth()

  if (loading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!user || user.role !== 'admin') {
    return <main className="container"><p className="error">{t('admin.errors.not_admin')}</p></main>
  }

  const cards = [
    ['/admin/users',        'users'],
    ['/admin/courses',      'courses'],
    ['/admin/categories',   'categories'],
    ['/admin/waitlist',     'waitlist'],
    ['/admin/presences',    'presences'],
    ['/admin/billing',      'billing'],
    ['/admin/prepay',       'prepay'],
    ['/admin/discounts',    'discounts'],
    ['/admin/announcements', 'announcements'],
    ['/admin/payments',     'payments'],
    ['/admin/organization', 'org'],
  ]

  return (
    <main className="container">
      <h1>{t('admin.title')}</h1>
      <p className="muted">{t('admin.intro')}</p>

      <ul className="admin-card-grid">
        {cards.map(([to, key]) => (
          <li key={key} className="admin-card">
            <h2><Link to={to}>{t(`admin.cards.${key}_title`)}</Link></h2>
            <p className="muted">{t(`admin.cards.${key}_desc`)}</p>
          </li>
        ))}
      </ul>
    </main>
  )
}
